// src/components/admin/sales/SettingsTab.tsx
// Aba de Configurações - REFATORADO GRAIA

import React, { useState } from 'react';
import { AlertTriangle, Trash2, RefreshCw, X } from 'lucide-react';
import './SettingsTab.css';

interface SettingsTabProps {
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const SettingsTab: React.FC<SettingsTabProps> = ({ onShowToast }) => {
    const [resetting, setResetting] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleResetAll = async () => {
        try {
            setResetting(true);
            const token = localStorage.getItem('accessToken');

            const response = await fetch('/api/admin/sales/reset-all', {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.ok) {
                const data = await response.json();
                onShowToast(`✅ Reset concluído: ${data.message}`, 'success');
                setShowConfirmModal(false);

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                const error = await response.json();
                onShowToast(error.message || 'Erro ao resetar dados', 'error');
            }
        } catch (error) {
            console.error('Erro:', error);
            onShowToast('Erro ao resetar dados', 'error');
        } finally {
            setResetting(false);
        }
    };

    return (
        <div className="st-container">
            <div className="st-header">
                <h2>Configurações de Sistema</h2>
                <p className="st-subtitle">
                    Ferramentas de administração e reset de dados de teste
                </p>
            </div>

            <div className="st-section">
                <h3>
                    <Trash2 size={20} />
                    Reset Completo de Dados de Vendas
                </h3>

                <div className="st-reset-card">
                    <div className="st-reset-info">
                        <h4>Resetar Tudo (Vendas, Compras e Estatísticas)</h4>
                        <p>Esta ação irá deletar permanentemente:</p>
                        <ul>
                            <li>Todas as vendas (Sales)</li>
                            <li>Todas as compras (Purchases)</li>
                            <li>Todos os cupons criados</li>
                            <li>Estatísticas de vendedores (saldo de comissão e total de vendas)</li>
                            <li>Histórico de vendas e assinaturas</li>
                        </ul>
                    </div>

                    <div className="st-warning-box">
                        <AlertTriangle size={16} />
                        <span>
                            <strong>Atenção:</strong> Os produtos do marketplace não serão deletados.
                            Apenas os registros de vendas e compras.
                        </span>
                    </div>

                    <button
                        className="st-btn-reset"
                        onClick={() => setShowConfirmModal(true)}
                        disabled={resetting}
                    >
                        {resetting ? (
                            <>
                                <RefreshCw size={18} className="st-spinning" />
                                Resetando...
                            </>
                        ) : (
                            <>
                                <Trash2 size={18} />
                                Resetar Tudo
                            </>
                        )}
                    </button>
                </div>
            </div>

            {/* MODAL DE CONFIRMAÇÃO */}
            {showConfirmModal && (
                <div className="st-modal-overlay" onClick={() => setShowConfirmModal(false)}>
                    <div className="st-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="st-modal-header">
                            <h3>Confirmar Reset Completo</h3>
                            <button
                                className="st-btn-close-modal"
                                onClick={() => setShowConfirmModal(false)}
                            >
                                <X size={20} />
                            </button>
                        </div>

                        <div className="st-modal-body">
                            <div className="st-confirm-icon">
                                <AlertTriangle size={48} />
                            </div>
                            <p className="st-confirm-text">
                                Tem certeza que deseja <strong>RESETAR TUDO</strong>?
                            </p>
                            <div className="st-confirm-warning">
                                <AlertTriangle size={14} />
                                <span>
                                    Esta ação é <strong>IRREVERSÍVEL</strong> e irá deletar:
                                    vendas, compras, cupons e estatísticas de vendedores.
                                </span>
                            </div>
                        </div>

                        <div className="st-modal-footer">
                            <button
                                className="st-btn-cancel"
                                onClick={() => setShowConfirmModal(false)}
                                disabled={resetting}
                            >
                                Cancelar
                            </button>
                            <button
                                className="st-btn-danger"
                                onClick={handleResetAll}
                                disabled={resetting}
                            >
                                {resetting ? (
                                    <>
                                        <RefreshCw size={16} className="st-spinning" />
                                        Resetando...
                                    </>
                                ) : (
                                    <>
                                        <Trash2 size={16} />
                                        Resetar Tudo
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SettingsTab;